"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IllegalStateError = void 0;
class IllegalStateError extends Error {
    constructor(msg) {
        super(msg ? `IllegalStateError: ${msg}` : "IllegalStateError");
    }
}
exports.IllegalStateError = IllegalStateError;
//# sourceMappingURL=IllegalStateError.js.map